export interface InitialApolloStoreState {
  user: any;
}

const initStore = (): InitialApolloStoreState => ({
  user: {
    __typename: 'User',
  },
});

export default initStore;
